export function resolveCartLine(items, identity) {
  const normalize = value => {
    if (value == null) return '[]';
    let entries;
    if (Array.isArray(value)) entries = value;
    else if (Object.prototype.toString.call(value) === '[object Object]') entries = Object.entries(value);
    else return null;
    const seen = new Set();
    for (const pair of entries) {
      if (!Array.isArray(pair) || pair.length !== 2 || typeof pair[0] !== 'string' || pair[0] === '' || seen.has(pair[0])) return null;
      const entryValue = pair[1];
      if (entryValue !== null && !['string', 'number', 'boolean'].includes(typeof entryValue)) return null;
      if (typeof entryValue === 'number' && !Number.isFinite(entryValue)) return null;
      seen.add(pair[0]);
    }
    return JSON.stringify([...entries].sort(([a], [b]) => a.localeCompare(b)));
  };
  const properties = normalize(identity.properties);
  if (properties === null || !Array.isArray(items)) return null;
  const matches = items.filter(item => item && String(item.variant_id) === String(identity.variant)
    && normalize(item.properties) === properties
    && String(item.selling_plan_allocation?.selling_plan?.id || '') === String(identity.plan || ''));
  const exact = matches.filter(item => item.key === identity.key);
  return exact.length === 1 ? exact[0] : matches.length === 1 ? matches[0] : null;
}

if (typeof document !== 'undefined' && document.documentElement.dataset.riderCartActionsBound !== '1') {
  document.documentElement.dataset.riderCartActionsBound = '1';
  async function changeQuantity(event, control, quantity) {
    const row = control.closest('[data-rider-cart-line]');
    if (!row) return;
    event.preventDefault();
    event.stopImmediatePropagation();
    const form = row.closest('.cart-page');
    const page = row.closest('.rider-cart-page');
    const flow = window.RiderCartFlow;
    let token;
    try {
      if (!Number.isSafeInteger(quantity) || quantity < 0) throw new Error('invalid-quantity');
      if (!flow || flow.version !== 1 || !form) throw new Error('cart-flow-unavailable');
      if (flow.isBusy(form)) return;
      token = flow.begin(form, 'quantity');
      if (!token) return;
      await flow.saveDraft(form);
      const root = window.Shopify?.routes?.root || '/';
      const cart = await flow.requestJson(`${root}cart.js`, { cache: 'no-store', credentials: 'same-origin' });
      if (!cart || !Array.isArray(cart.items)) throw new Error('cart-read-malformed');
      const identity = {
        variant: row.dataset.variant,
        properties: JSON.parse(row.dataset.properties || '{}'),
        plan: row.dataset.plan,
        key: row.dataset.key
      };
      const item = resolveCartLine(cart.items, identity);
      if (!item) throw new Error('line-changed');
      const updated = await flow.requestJson(`${root}cart/change.js`, {
        method: 'POST', credentials: 'same-origin',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({ id: item.key, quantity })
      });
      if (!updated || !Array.isArray(updated.items)) throw new Error('cart-change-malformed');
      const changed = quantity ? resolveCartLine(updated.items, { ...identity, key: item.key }) : null;
      if (quantity ? changed?.quantity !== quantity : updated.items.some(line => line.key === item.key)) throw new Error('cart-change-mismatch');
      window.location.reload();
    } catch {
      if (flow?.version === 1) flow.showStatus(form, true);
      else {
        const status = page?.querySelector('[data-rider-cart-status]');
        if (status) {
          status.textContent = page.dataset.changeError;
          status.setAttribute('role', 'alert');
          status.hidden = false;
        }
      }
    } finally { flow?.end(token); }
  }
  document.addEventListener('click', event => {
    if (event.button !== 0 || event.metaKey || event.ctrlKey || event.shiftKey || event.altKey) return;
    const link = event.target.closest?.('.rider-cart-page line-item-quantity a[href]');
    if (!link) return;
    const url = new URL(link.href, window.location.href);
    if (!url.pathname.endsWith('/cart/change') || !url.searchParams.has('quantity')) return;
    changeQuantity(event, link, Number(url.searchParams.get('quantity')));
  }, true);
  document.addEventListener('change', event => {
    const input = event.target.closest?.('.rider-cart-page line-item-quantity input[data-line-key]');
    if (!input) return;
    const quantity = input.value.trim() !== '' && input.validity?.valid !== false ? Number(input.value) : NaN;
    changeQuantity(event, input, quantity);
  }, true);
}
